import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { State as SharedState } from '@emm/shared/store/shared.reducer';
import { ThemeActions } from './theme.actions';
import { ThemeSelectors } from './theme.selectors';

export interface ThemeQueries {
    currentTheme$: Observable<string>;
}

@Injectable({ providedIn: 'root' })
export class ThemeStoreService {

    dispatch = {
        initTheme: () => this.store.dispatch(ThemeActions.init()),
        selectTheme: (theme: string) => this.store.dispatch(ThemeActions.selectTheme({theme})),
    };

    queries: ThemeQueries = {
        currentTheme$: this.store.select(ThemeSelectors.getTheme),
    };

    constructor(private store: Store<SharedState>) { }

}
